/**
 * True for Lex builds deployed to China (Hangzhou / artemlex.cn).
 * Gated by `VITE_WECHAT_AUTH_ENABLED`, which CI sets only for Hangzhou client deploys.
 */
export function isChinaFacingLexClient(): boolean {
  if (window.location.pathname.startsWith('/admin')) {
    return false
  }
  return import.meta.env.VITE_WECHAT_AUTH_ENABLED === 'true'
}
